import { ProductType } from '@/types';
import { assertDefined } from '@/utils/assertDefined';
import { trackError } from '@/utils/raygun';
import { getDefaultViewId } from './getDefaultViewId';
import { getView } from './getView';

export const getDefaultView = (productType: ProductType) => {
  try {
    return assertDefined(getView(productType, getDefaultViewId(productType)));
  } catch (error) {
    trackError('Invalid default view', { productType });
    return assertDefined(productType.views[0]);
  }
};
